import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@components/ui/dialog.tsx";
import { Trans } from "react-i18next";

import { Stack } from "@/sprout/layout";
import { PrimaryButton, TertiaryButton } from "@sprout/buttons";

type Props = {
  triggerText?: string;
};

const MissingApplicationsModal = ({ triggerText }: Props) => {
  return (
    <Dialog>
      <DialogTrigger>
        <TertiaryButton secondary>
          {triggerText ? triggerText : <Trans i18nKey="applications:learn_why" />}
        </TertiaryButton>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            <Trans i18nKey="applications:not_found_modal:title" />
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          <Stack>
            <Trans i18nKey="applications:not_found_modal:explanation" />
          </Stack>
        </DialogDescription>
        <DialogFooter>
          <DialogClose>
            <PrimaryButton>
              <Trans i18nKey="applications:not_found_modal:close" />
            </PrimaryButton>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default MissingApplicationsModal;
